import React from 'react';
import { View } from 'react-native';
import { getDividerStyle } from './utils/getDividerStyle';
const BMDivider = (props) => {
    const { orientation = 'HORIZONTAL', length = 'STRETCH', type = 'BOLD', alignment = 'LEFT', borderColor, lineLength, testID, } = props;
    const dividerLength = length === 'STRETCH' ? length : lineLength;
    const lineStyle = getDividerStyle({ orientation, length: dividerLength, type, alignment });
    const color = type === 'CUSTOM' && borderColor ? { backgroundColor: borderColor } : {};
    return <View style={{ ...lineStyle, ...color }} testID={testID}/>;
};
export default BMDivider;
